

export default {
    props: [
        'error',
    ],

  computed: {
    message: function () {
      let message = this.error?.message || "Страница не найдена";
      if (message === "Page not found" || message === 'Category error not found') {
        message = "Страница не найдена"
      }

      return message
    }
  }
};
